import React from "react";
import PropTypes from "prop-types";
import { Typography, Box, ButtonBase } from "@material-ui/core";
import { LOCATION_LEVEL_ICONS } from "../constants";
import { findNode } from "../utils";
import { SectionHeading } from "./UI";
import { LocationTreeSidebar } from "./LocationTreeSidebar";
import { useStyles } from "../views/wizard-view.style";

export function WizardLocationStep({ wizardSearch, setWizardSearch, wizardChecked, wizardCheck, treeExpanded, onTreeToggle, wizardLeafs, locations }) {
  const classes = useStyles();
  const expandedSet = treeExpanded ?? new Set();
  return (
    <Box className={classes.locationStepRoot}>
      <LocationTreeSidebar
        search={wizardSearch}
        onSearchChange={setWizardSearch}
        searchPlaceholder="Search..."
        locations={locations}
        mode="select"
        checked={wizardChecked}
        onCheck={wizardCheck}
        expanded={expandedSet}
        onToggle={onTreeToggle}
      />
      <Box sx={{ flex: 1 }}>
        <SectionHeading>
          Selected ({wizardLeafs.length} target{wizardLeafs.length === 1 ? "" : "s"})
        </SectionHeading>
        {wizardChecked.size === 0 && (
          <Typography className={classes.emptySelectionMessage}>
            Select locations from the tree.
          </Typography>
        )}
        {wizardChecked.size > 0 && (
          <Box className={classes.selectedChips}>
            {[...wizardChecked].map((id) => {
              const node = findNode(locations, id);
              if (!node) return null;
              return (
                <Box key={id} component="span" className={classes.selectedChip}>
                  {LOCATION_LEVEL_ICONS[node.level]} {node.name}{" "}
                  <ButtonBase
                    onClick={() => wizardCheck(id, [id])}
                    className={classes.chipRemoveButton}
                  >
                    &times;
                  </ButtonBase>
                </Box>
              );
            })}
          </Box>
        )}
      </Box>
    </Box>
  );
}

WizardLocationStep.propTypes = {
  wizardSearch: PropTypes.string,
  setWizardSearch: PropTypes.func.isRequired,
  wizardChecked: PropTypes.instanceOf(Set),
  wizardCheck: PropTypes.func.isRequired,
  treeExpanded: PropTypes.instanceOf(Set),
  onTreeToggle: PropTypes.func.isRequired,
  wizardLeafs: PropTypes.array,
  locations: PropTypes.array,
};

WizardLocationStep.defaultProps = {
  wizardSearch: "",
  wizardChecked: new Set(),
  treeExpanded: undefined,
  wizardLeafs: [],
  locations: [],
};
